export default {
  INCHAT_UPDATE_CONVERSATION: 'INCHAT_UPDATE_CONVERSATION',
  INCHAT_GET_DIRECT_CONVERSATIONS_LIST: 'INCHAT_GET_DIRECT_CONVERSATIONS_LIST',
  INCHAT_GET_INFO_MAIN_MENU: 'INCHAT_GET_INFO_MAIN_MENU',
  INCHAT_ADD_CONVERSATIONS: 'INCHAT_ADD_CONVERSATIONS',
  INCHAT_UPDATE_CHAT_STATE: 'INCHAT_UPDATE_CHAT_STATE',
  INCHAT_SET_CONVERSATION_MESSAGES: 'INCHAT_SET_CONVERSATION_MESSAGES',
  INCHAT_SET_SCHEDULED_MESSAGES: 'INCHAT_SET_SCHEDULED_MESSAGES',
  INCHAT_SET_SCHEDULED_MESSAGE_TO_EDIT: 'INCHAT_SET_SCHEDULED_MESSAGE_TO_EDIT',
  INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES: 'INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES',
  INCHAT_COMPOSER_EDIT_MESSAGE: 'INCHAT_COMPOSER_EDIT_MESSAGE',
  INCHAT_SET_NEW_DIRECT_MESSAGE: 'INCHAT_SET_NEW_DIRECT_MESSAGE',
  INCHAT_COMPOSER_ADD_ATTACHMENTS: 'INCHAT_COMPOSER_ADD_ATTACHMENTS',
  INCHAT_COMPOSER_EDIT_MENTIONS: 'INCHAT_COMPOSER_EDIT_MENTIONS',
  INCHAT_COMPOSER_CLEAN: 'INCHAT_COMPOSER_CLEAN',
  INCHAT_COMPOSER_UPLOADING_FILE: 'INCHAT_COMPOSER_UPLOADING_FILE',
  INCHAT_UPDATE_CONVERSATIONS: 'INCHAT_UPDATE_CONVERSATIONS',
  INCHAT_COMPOSER_REMOVE_ATTACHMENT: 'INCHAT_COMPOSER_REMOVE_ATTACHMENT',
  INCHAT_REMOVE_CONVERSATION: 'INCHAT_REMOVE_CONVERSATION',
  INCHAT_REMOVE_ALL_CONVERSATIONS: 'INCHAT_REMOVE_ALL_CONVERSATIONS',
  INCHAT_ON_TOGGLE_THREADS: 'INCHAT_ON_TOGGLE_THREADS',
  INCHAT_SET_RESPONSES_ON_MESSAGES: 'INCHAT_SET_RESPONSES_ON_MESSAGES',
  INCHAT_SET_THREADS_MESSAGES: 'INCHAT_SET_THREADS_MESSAGES',
  INCHAT_SET_NEW_THREAD_MESSAGE: 'INCHAT_SET_NEW_THREAD_MESSAGE',
  INCHAT_UPDATE_THREAD_STATE: 'INCHAT_UPDATE_THREAD_STATE',
  INCHAT_UPDATE_USERS_CONVERSATION: 'INCHAT_UPDATE_USERS_CONVERSATION',
  INCHAT_UPDATE_FILTERS_DIRECT: 'INCHAT_UPDATE_FILTERS_DIRECT',
  INCHAT_UPDATE_SECTIONS: 'INCHAT_UPDATE_SECTIONS',
  INCHAT_UPDATE_ORDER_SECTIONS: 'INCHAT_UPDATE_ORDER_SECTIONS',
  INCHAT_UPDATE_MESSAGE_REACTIONS: 'INCHAT_UPDATE_MESSAGE_REACTIONS',
  INCHAT_REMOVE_SECTION: 'INCHAT_REMOVE_SECTION',
  INCHAT_MOVE_CONVERSATIONS_SECTIONS_DIRECT: 'INCHAT_MOVE_CONVERSATIONS_SECTIONS_DIRECT',
  INCHAT_SET_PINNED_MESSAGES: 'INCHAT_SET_PINNED_MESSAGES',
  INCHAT_SET_DRAFTS: 'INCHAT_SET_DRAFTS',
  INCHAT_SET_DRAFT_ID: 'INCHAT_SET_DRAFT_ID',
  INCHAT_MESSAGE_UPDATE_EXTERNAL: 'INCHAT_MESSAGE_UPDATE_EXTERNAL',
  INCHAT_UPDATE_COUNT_PINNED_MESSAGES: 'INCHAT_UPDATE_COUNT_PINNED_MESSAGES',
  INCHAT_UPDATE_COUNT_SAVED_MESSAGES: 'INCHAT_UPDATE_COUNT_SAVED_MESSAGES',
  INCHAT_UPDATE_COUNT_DRAFT_MESSAGES: 'INCHAT_UPDATE_COUNT_DRAFT_MESSAGES',
  INCHAT_UPDATE_COUNT_MENTIONS_REACTIONS: 'INCHAT_UPDATE_COUNT_MENTIONS_REACTIONS',
  INCHAT_UPDATE_INFO_CONVERSATION_COMPOSER: 'INCHAT_UPDATE_INFO_CONVERSATION_COMPOSER',
  INCHAT_UPDATE_UNREAD_MESSAGES: 'INCHAT_UPDATE_UNREAD_MESSAGES'
}
